import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

import Chip from '@eig-builder/core-ui/Chip'

import FAAS_DECISION from '../../enums/faas-decision'

import Text from '@eig-builder/module-localization'
import './lang'

const styles = theme => ({
  chip: {
    height: 22
  },
  paid: {
    backgroundColor: theme.palette.success.main,
    color: 'white'
  },
  cancelled: {
    backgroundColor: theme.palette.error.main,
    color: 'white'
  },
  faasDeclined: {
    backgroundColor: theme.palette.warning.main,
    marginLeft: theme.spacing(2)
  }
})

const AccountStatusChip = ({ account, classes, faasStatus }) => {
  const cancelledAccount = account.deleted && account.deleted.length > 0
  const paidAccount = (account.isPaid || account.is_paid) && (account.uberClientId || account.uber_client_id) && !cancelledAccount

  const statusClass = classNames({
    [`${classes.cancelled}`]: cancelledAccount,
    [`${classes.paid}`]: paidAccount,
    [classes.faasDeclined]: faasStatus === FAAS_DECISION.DECLINED
  })

  const chipText = cancelledAccount ? 'cancelled' : paidAccount ? 'paid' : 'free'
  const faasText = faasStatus === FAAS_DECISION.DECLINED && 'FaaS: Orders blocked'

  return (
    <Chip
      className={`${classes.chip} ${statusClass}`}
      label={faasText || <Text message={`modules.crm.components.accountStatusChip.${chipText}`} />}
      />
  )
}

AccountStatusChip.propTypes = {
  account: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  faasStatus: PropTypes.oneOf([FAAS_DECISION.APPROVED, FAAS_DECISION.DECLINED, FAAS_DECISION.REVIEW])
}

export default withStyles(styles)(AccountStatusChip)
